import { useEffect, useRef } from "react";
import { useMap } from "react-leaflet";

export interface CenterOnStationProps {
  latitude: number;
  longitude: number;
}

export const CenterOnStation = ({ latitude, longitude }: CenterOnStationProps) => {
  const map = useMap();
  const isFirstRender = useRef(true);

  useEffect(() => {
    // Skip the first render since MapContainer already handles initial center
    if (isFirstRender.current) {
      isFirstRender.current = false;
      return;
    }

    if (latitude != null && longitude != null) {
      map.setView([latitude, longitude], map.getZoom());
    }
  }, [latitude, longitude, map]);

  return null;
};
